export type LogLevel = "info" | "error";

export interface LogEntry {
    timestamp: string;
    type: LogLevel;
    details?: Record<string, any>;
}

const getTimestamp = (): string =>
    new Date().toLocaleString("en-IN", {
        timeZone: "Asia/Kolkata",
        hour12: false,
    });

const logActivity = async (type: LogLevel, details: Record<string, any> = {}) => {
    const log: LogEntry = {
        timestamp: getTimestamp(),
        type,
        details,
    };

    // console[type === "info" ? "info" : "error"](`[${type.toUpperCase()}]`, log);

    try {
        await fetch("/api/log", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(log),
        });
    } catch (err) {
        console.warn("Backend logging failed:", err);
    }
};

export const logInfo = (details: Record<string, any>) => logActivity("info", details);
export const logError = (details: Record<string, any>) => logActivity("error", details);
